/**
 * @generated SignedSource<<e84a556f78136aae70e326650a871db1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateSelectorTemplateItem_TodoWorkspaceTemplate$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TemplateSelectorTemplateItem_TodoWorkspaceTemplate";
};
export type TemplateSelectorTemplateItem_TodoWorkspaceTemplate$key = {
  readonly " $data"?: TemplateSelectorTemplateItem_TodoWorkspaceTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateSelectorTemplateItem_TodoWorkspaceTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateSelectorTemplateItem_TodoWorkspaceTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "TodoWorkspaceTemplate",
  "abstractKey": null
};

(node as any).hash = "d81cc3209b4c03a3eb63bf6a478de7bc";

export default node;
